class Filters {
    constructor() {
        this.displayFilters();
        this.submitBtn = document.querySelector('.search-btn');

        if (!this.submitBtn) {
            return;
        }

        this.submitBtn.addEventListener('click', () => {
            let url = new URL(window.location.href.split('?')[0]);
            const shapesFilter = document.querySelectorAll('.shapes-check:checked');
            const typesFilter = document.querySelectorAll('.types-check:checked');
            const categoriesFilter = document.querySelectorAll('.categories-check:checked');
            let shapesArray = [];
            let typesArray = [];
            let categoriesArray = [];

            shapesFilter.forEach(item => {
                shapesArray.push(item.value);
            });

            typesFilter.forEach(item => {
                typesArray.push(item.value);
            });

            categoriesFilter.forEach(item => {
                categoriesArray.push(item.value);
            });

            let params = url.searchParams;
            if (shapesArray.length) {
                params.append("formes-de-modeles", shapesArray.join(','));
            }
            if (typesArray.length) {
                params.append("types-de-modeles", typesArray.join(','));
            }
            if (categoriesArray.length) {
                params.append("styles-de-modeles", categoriesArray.join(','));
            }
            window.location.href = url.toString();
        });

        this.restoreFilters();

        const clearBtn = document.querySelector('.clear-btn');
        clearBtn.addEventListener('click', () => {
            this.clearFilter();
        });
    }

    displayFilters() {
        document.querySelectorAll('.filter').forEach(filter => {
            filter.querySelector('.filter__title').addEventListener('click', () => {
                filter.querySelector('.filter__wrap').classList.toggle('filter__wrap--open');
                filter.querySelector('.filter__title').classList.toggle('filter__title--open');
                filter.classList.toggle('filter--open');
            });
        });
    }

    scrollToFilters() {
        const scrollTop = document.querySelector(".filters-scroll-anchor").getBoundingClientRect().top;
        window.scrollTo({
            top: scrollTop,
            behavior: "instant"
        });
    }

    restoreFilters() {
        this.urlSearchParams = new URLSearchParams(window.location.search);
        if (Array.from(this.urlSearchParams).length) {
            this.scrollToFilters();
            this.restoreFilter("formes-de-modeles", ".filter__shapes");
            this.restoreFilter("types-de-modeles", ".filter__types");
            this.restoreFilter("styles-de-modeles", ".filter__categories");
        }
    }

    restoreFilter(queryParamName, inputName) {
        const stringValues = this.urlSearchParams.get(queryParamName);

        if (stringValues) {
            let values = stringValues.split(",");
            const inputs = document.querySelectorAll(`${inputName} input`);
            inputs.forEach(input => {
                if (values.includes(input.value)) {
                    input.checked = true;
                }
            });
        }
    }

    clearFilter() {
        const inputsChecked = document.querySelectorAll('.filter input[type=checkbox]:checked');
        inputsChecked.forEach(item => {
            item.checked = false;
        });

        this.submitBtn.click();
    }
}